"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NaiveSheet = void 0;
const NaiveRow_1 = require("./NaiveRow");
class NaiveSheet {
    constructor(name, rows) {
        this.name = name;
        this.rows = rows.map((columns, index) => new NaiveRow_1.NaiveRow(index, columns));
    }
}
exports.NaiveSheet = NaiveSheet;
